import { FunctionComponent } from "react";
import LoadingAnimation from "./LoadingAnimation";

type LoaderProps = {
    title?: string,
    message: string,
    subtitle?: boolean
}

/**
 * Loader displays a loading spinner with an optional message
 * message is mandatory for aria-label but is not displayed as subtitle by default.
 * @param title - Main title displayed next to the spinner
 * @param message - Accessible message for screen readers, optionally displayed as subtitle
 * @param subtitle - Whether to display the message as a visible subtitle
 * @returns JSX.Element
 */
const Loader: FunctionComponent<LoaderProps> = ({
    title = "Loading...",
    message,
    subtitle = false
}) => {
    return (
        <div
            className="flex h-full items-center justify-center absolute inset-0 z-10"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label={message}
        >
            <div className="flex flex-col items-center ">
                <div className="flex items-center ">
                    <LoadingAnimation className="w-8 h-8"/>
                    <span className="text-xl pl-2 text-gray-700 dark:text-gray-300">
                        {title}
                    </span>
                </div>
                {subtitle && (
                    <span className="text-gray-600 dark:text-gray-400 mt-2">
                        {message}
                    </span>
                )}
            </div>
        </div>
    )
}
export default Loader;